import React from 'react';

export function SectionLabel({ children, icon }) {
  const Icon = icon;
  return (
    <p className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-400">
      {Icon && <Icon className="-mt-px h-3.5 w-3.5" />}
      {children}
    </p>
  );
}
